import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  currentShift: null,
  allShifts: [],
  selectedShift: null,
  success: false,
  error: null,
  message: null,
};

export const shiftReducer = createReducer(initialState, (builder) => {
  builder
    // Start Shift
    .addCase("startShiftRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("startShiftSuccess", (state, action) => {
      state.isLoading = false;
      state.currentShift = action.payload;
      state.success = true;
    })
    .addCase("startShiftFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Load Shift
    .addCase("loadShiftRequest", (state) => {
      state.isLoading = true;
      state.currentShift = null; // Clear previous shift data on new load
    })
    .addCase("loadShiftSuccess", (state, action) => {
      state.isLoading = false;
      state.currentShift = action.payload;
    })
    .addCase("loadShiftFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // End Shift
    .addCase("endShiftRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("endShiftSuccess", (state) => {
      state.isLoading = false;
      state.currentShift = null;
      state.success = true;
    })
    .addCase("endShiftFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Clear Errors
    .addCase("clearShiftErrors", (state) => {
      state.error = null;
    })

    // Clear Success
    .addCase("clearShiftSuccess", (state) => {
      state.success = false;
      state.message = "";
    })

    // Get All Shifts
    .addCase("getAllShiftsRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("getAllShiftsSuccess", (state, action) => {
      state.isLoading = false;
      state.allShifts = action.payload;
    })
    .addCase("getAllShiftsFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Get Shift By ID
    .addCase("getShiftByIdRequest", (state) => {
      state.isLoading = true;
      state.selectedShift = null; // Clear previous selected shift data
    })
    .addCase("getShiftByIdSuccess", (state, action) => {
      state.isLoading = false;
      state.selectedShift = action.payload;
    })
    .addCase("getShiftByIdFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Get Shifts By Store
    .addCase("getShiftsByStoreRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("getShiftsByStoreSuccess", (state, action) => {
      state.isLoading = false;
      state.allShifts = action.payload;
    })
    .addCase("getShiftsByStoreFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Delete Shift
    .addCase("deleteShiftRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("deleteShiftSuccess", (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.message = "Shift deleted successfully";
      // Remove the deleted shift from allShifts
      state.allShifts = state.allShifts.filter(shift => shift._id !== action.payload.shiftId);
    })
    .addCase("deleteShiftFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Clear Errors
    .addCase('clearErrors', (state) => {
      state.error = null;
    })

    // Clear Success Messages
    .addCase('clearSuccess', (state) => {
      state.message = null;
      state.success = false;
    });
});
